import { useState } from 'react';
import { ProductFaq } from './product.styles';

export type FaqItem = { question: string; answer: string };

/**
 * Accordion FAQ section for product pages. Pass the same `faq` array to the page's
 * Container `faq` prop so the visible questions stay in sync with the FAQPage schema.
 */
export default function ProductFaqSection({ faq }: { faq: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <ProductFaq id="faq">
      <h3>FAQ</h3>
      <div className="faq-list">
        {faq.map((item, i) => {
          const isOpen = openIndex === i;
          return (
            <div className={`faq-item${isOpen ? ' open' : ''}`} key={item.question}>
              <button
                type="button"
                className="question"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex(isOpen ? null : i)}
              >
                {item.question}
              </button>
              <div className="answer-wrap">
                <div className="answer">
                  <div className="answer-inner">{item.answer}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </ProductFaq>
  );
}
